import { apiClient } from '../../common/ApiClient';
import { createApiMutationHook } from '../../common/queryClient/createApiMutationHook';
import type { ISODate } from '../../common/utils';
import { ValidationDashboardUrl } from './ValidationDashboardUrl';

const postVisualValidationTimeSeries = (data: {
  dataObjectVersionIds: number[];
  valueDateFrom: ISODate;
  valueDateTo: ISODate;
  ruleCode: string;
  outliers: boolean;
  hp: boolean;
}) => {
  let url: string = ValidationDashboardUrl.TIME_SERIES;
  if (data.hp) {
    url = ValidationDashboardUrl.HODRICK_PRESCOTT;
  } else if (data.outliers) {
    url = ValidationDashboardUrl.OUTLIERS;
  }
  return apiClient
    .post<{ externalCode: string }>(url, data)
    .then((response) => response.data);
};

export const useGenerateVisualValidationTimeSeriesMutation =
  createApiMutationHook(
    ['visualValidationTimeSeries'],
    postVisualValidationTimeSeries,
  );
